var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLockIcon = function SvgLockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    fillRule: "evenodd",
    d: "M10 6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0zM6 1.333A2.667 2.667 0 0 1 8.667 4v2H3.333V4A2.667 2.667 0 0 1 6 1.333m4 6H2A.667.667 0 0 0 1.333 8v4c0 .368.299.667.667.667h8a.667.667 0 0 0 .667-.667V8A.667.667 0 0 0 10 7.333",
    clipRule: "evenodd"
  })));
};
export default SvgLockIcon;